export class MapaINControlNames {

  public static facturationEtat = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region';
  public static facturationSiret = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret';

  public static adr3 = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_adr3';


  public static getCtrl_72Names_json(): any {
    const dateCandid = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures';
    return {date: dateCandid};
  }

  public static getCtrl_1222Names_json(): any {
    return {etat: MapaINControlNames.facturationEtat, siret: MapaINControlNames.facturationSiret};
  }

  public static getCtrl_1198Names_json(): any {
    const deptPublicationRappel = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel';
    return {firstChamp: deptPublicationRappel};
  }

  public static getCtrl_1206Names_json(): any {
    const motsClef = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeMotsClef_SepAtt_motClef';
    return {motsClef: motsClef};
  }

  public static getCtrl_237Names_json(): any {
    const deptPub = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const deptPublicationRappel = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel';
    return {firstChamp: deptPub, secondChamp: deptPublicationRappel};
  }

  public static getCtrl_38Names_json(): any {
    const nomAdmEtTech = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypePers_SepAtt_nom';
    const nomAdmOuTechAdm = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_38_1_SepSep_TypeAdresseComplete_SepSep_TypePers_SepAtt_nom';
    const nomAdmOuTechTech = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_38_1_SepSep_TypeAdresseComplete_SepSep_TypePers_SepAtt_nom';
    const nomDocument = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypePers_SepAtt_nom';
    const nomEnvoi = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypePers_SepAtt_nom';
    const nomRensComplementaires = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypePers_SepAtt_nom';
    return {
      firstChamp: nomAdmEtTech, secondChamp: nomAdmOuTechAdm, troisiemeChamp: nomAdmOuTechTech,
      quatriemeChamp: nomDocument, cinquiemeChamp: nomEnvoi, sixiemeChamp: nomRensComplementaires
    };
  }

  public static getCtrl_40Names_json(typeInstance: string, nbIteration: number): any {

    switch (typeInstance) {
      case 'rensComplementaires':
        return {
          firstChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'envoi':
        return {
          firstChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'document':
        return {
          firstChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'admEtTech':
        return {
          firstChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'adm':
        return {
          firstChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'tech':
        return {
          firstChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
    }
  }

  public static getCtrl_40_voieeNames_json(typeInstance: string, nbIteration: number): any {

    switch (typeInstance) {
      case 'rensComplementaires':
        return {
          firstChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'envoi':
        return {
          firstChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'document':
        return {
          firstChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'admEtTech':
        return {
          firstChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'adm':
        return {
          firstChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
      case 'tech':
        return {
          firstChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          secondChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
          thirdChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie'
        };
    }
  }

  public static getCtrl_1Names_json(typeInstance: string, nbIteration: number): any {

    switch (typeInstance) {
      case 'rensComplementaires':
        return {
          firstChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',

        };
      case 'envoi':
        return {
          firstChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voie_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'document':
        return {
          firstChamp: 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voiedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'admEtTech':
        return {
          firstChamp: 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'adm':
        return {
          firstChamp: 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie'
        };
      case 'tech':
        return {
          firstChamp: 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp',
          secondChamp: 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voietech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie'
        };
    }
  }

  public static getCtrl_1_voieeNames_json(typeInstance: string, nbIteration: number): any {

    switch (typeInstance) {
      case 'rensComplementaires':
        return {
          firstChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',

        };
      case 'envoi':
        return {
          firstChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voiee_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'document':
        return {
          firstChamp: 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieedocument_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'admEtTech':
        return {
          firstChamp: 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieeadmEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie',
        };
      case 'adm':
        return {
          firstChamp: 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieeadm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie'
        };
      case 'tech':
        return {
          firstChamp: 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp_e',
          secondChamp: 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville',
          thirdChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num',
          fourthChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie',
          fifthChamp: 'voieetech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_' + nbIteration + '_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie'
        };
    }
  }

  public static getCtrl_418Names_json(): any {
    const dateCandid = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures';
    return {date: dateCandid};
  }

  public static getCtrl_1211Names_json(): any {
    const nameServiceExec = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeFacturation_SepAtt_noServiceExecutant';
    return {name: nameServiceExec};
  }

  public static getCtrl_8Names_json(): any {
    const respMarcheNom = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_nom';
    const respMarchePrenom = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_prenom';
    const respMarcheFonc = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_fonc';
    const respMarcheCivilite = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_civilite';
    return {nom: respMarcheNom, prenom: respMarchePrenom, fonc: respMarcheFonc, civilite: respMarcheCivilite};
  }

  public static getCtrl_9Names_json(): any {
    const respMarcheNom = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_nom';
    const respMarchePrenom = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_prenom';
    const respMarcheFonc = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_fonc';
    const respMarcheCivilite = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypePers_SepAtt_civilite';
    return {nom: respMarcheNom, prenom: respMarchePrenom, fonc: respMarcheFonc, civilite: respMarcheCivilite};
  }

  public static getCtrl_33Names_json(): any {
    const melAdmEtTech = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_mel';
    const melAdmOuTechAdm = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_33_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_mel';
    const melAdmOuTechTech = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_33_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_mel';
    const melDocument = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_mel';
    const melEnvoi = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeCoord_SepAtt_mel';
    const melRens = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeCoord_SepAtt_mel';
    return {
      melAdmEtTech, melAdmOuTechAdm, melAdmOuTechTech
      , melDocument, melEnvoi, melRens
    };
  }

  public static getCtrl_34Names_json(): any {
    const urlAdmEtTech = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_url';
    const urlAdmOuTechAdm = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_33_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_url';
    const urlAdmOuTechTech = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_33_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_url';
    const urlDocument = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_url';
    const urlEnvoi = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeCoord_SepAtt_url';
    const urlRens = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeCoord_SepAtt_url';
    return {
      urlAdmEtTech, urlAdmOuTechAdm, urlAdmOuTechTech
      , urlDocument, urlEnvoi, urlRens
    };
  }

  public static getCtrl_430Names_json(): any {
    const delaisDateJusquau = '_SepSep_Initial_SepSep_TypeDelais_SepSep_Validite_SepAtt_dateJusquau';
    return {date: delaisDateJusquau};
  }

  public static getCtrl_431Names_json(): any {
    const dateCandid = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures';
    return {date: dateCandid};
  }

  public static getCtrl_432Names_json(): any {
    const dateRecepOffre = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptionOffres';
    return {date: dateRecepOffre};
  }

  public static getCtrl_433Names_json(): any {
    const dateDebutPresta = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateDebutPrestation';
    return {date: dateDebutPresta};
  }

  public static getCtrl_434Names_json(): any {
    const delaisDateJusquau = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateDebutTravaux';
    return {date: delaisDateJusquau};
  }

  public static getCtrl_1002Names_json(iter): any {
    const critPond = '_SepSep_Initial_SepSep_TypeCrJugement_index_' + iter + '_SepSep_CriterePondere_SepAtt_critere';
    const critPondPCT = '_SepSep_Initial_SepSep_TypeCrJugement_index_' + iter + '_SepSep_CriterePondere_SepAtt_criterePCT';
    return {critPond, critPondPCT};
  }

  public static getCtrl_1162Names_json(): any {
    const criterePCT = '_SepSep_Initial_SepSep_TypeCrJugement_index_INDEX_1162_1_SepSep_CriterePondere_SepAtt_criterePCT';
    return {criterePCT};
  }

  public static getCtrl_19Names_json(): any {
    const dateJusquau = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateJusquau';
    const dateACompterDu = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateACompterDu';
    return {firstChamp: dateACompterDu, secondChamp: dateJusquau};
  }

  public static getCtrl_20Names_json(): any {
    const dateACompterDu = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateACompterDu';
    return {firstChamp: dateACompterDu};
  }

  public static getCtrl_77Names_json(): any {
    const dateRecepOffre = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptionOffres';
    return {date: dateRecepOffre};
  }

  public static getCtrl_410Names_json(): any {
    const dateReceptCandidature = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures';
    const dateEnvoiInvitation = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_envoiInvitation';
    return {dateEnvoiInvitation, dateReceptCandidature};
  }

  public static getCtrl_411Names_json(): any {
    const dateReceptCandidature = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures';
    const dateRecepOffre = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptionOffres';
    return {dateRecepOffre, dateReceptCandidature};
  }

  public static getCtrl_443Names_json(): any {
    const dateFinDiffusion = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return {dateFinDiffusion};
  }

  public static getCtrl_444Names_json(): any {
    const dateFinDiffusion = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return {dateFinDiffusion};
  }

  public static getCtrl_445Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return {firstChamp};
  }

  public static getCtrl_16Names_json(): any {
    const nbJours = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbJours';
    const nbMois = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbMois';
    const dateACompterDu = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateACompterDu';
    const dateJusquau = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_dateJusquau';
    return {firstChamp: dateACompterDu, secondChamp: dateJusquau, thirdChamp: nbJours, fourthChamp: nbMois};
  }

  public static getCtrl_14Names_json(): any {
    const nbMois = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbMois';
    return {nbMois};
  }

  public static getCtrl_15Names_json(): any {
    const nbJours = '_SepSep_Initial_SepSep_TypeDureeMarche_SepAtt_nbJours';
    return {nbJours};
  }

  public static getCtrl_31Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_31_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_31_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeCoord_SepAtt_tel';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeCoord_SepAtt_tel';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp};
  }

  public static getCtrl_36Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepAtt_personneMorale';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_36_1_SepSep_TypeAdresseComplete_SepAtt_personneMorale';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_36_1_SepSep_TypeAdresseComplete_SepAtt_personneMorale';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepAtt_personneMorale';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepAtt_personneMorale';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepAtt_personneMorale';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp};
  }

  public static getCtrl_43Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_43_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_43_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_cp';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_cp';
    const seventhChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    const eigththChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    const ninthChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp, seventhChamp, eigththChamp, ninthChamp};
  }

  public static getCtrl_48Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_pays';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_48_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_pays';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_48_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_pays';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_pays';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_pays';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_pays';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp};
  }

  public static getCtrl_57Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Renseignements_SepAtt_idMarche';
    return {firstChamp};
  }

  public static getCtrl_65Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Renseignements_SepAtt_rensgComplt';
    return {firstChamp};
  }

  public static getCtrl_67Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Conditions_SepAtt_garanties';
    return {firstChamp};
  }

  public static getCtrl_69Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Conditions_SepAtt_modFinancement';
    return {firstChamp};
  }

  public static getCtrl_71Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Conditions_SepAtt_formeJuridique';
    return {firstChamp};
  }


  public static getCtrl_105Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepAtt_cp';
    return {firstChamp};
  }

  public static getCtrl_106Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    return {firstChamp};
  }

  public static getCtrl_107Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Description_SepAtt_objet';
    return {firstChamp};
  }

  public static getCtrl_123Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Description_SepAtt_objet';
    return {firstChamp};
  }

  public static getCtrl_150Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_TypeLotsMAPA_index_INDEX_150_1_SepSep_Lot_SepAtt_numLot';
    return {firstChamp};
  }

  public static getCtrl_151Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_TypeLotsMAPA_index_INDEX_151_1_SepSep_Lot_SepAtt_description';
    return {firstChamp};
  }

  public static getCtrl_153Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_TypeLotsMAPA_index_INDEX_153_1_SepSep_Lot_SepAtt_description';
    return {firstChamp};
  }

  public static getCtrl_202Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    const secondChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_202LieuExecLivraisonNames_json(): any {
    const firstChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    const secondChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_203Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville';
    const secondChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_203LieuExecLivraisonNames_json(): any {
    const firstChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville';
    const secondChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_204Names_json(): any {
    const firstChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    const secondChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_205Names_json(): any {
    const firstChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_ville';
    const secondChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie';
    const thirdChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num';
    const fourthChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_208Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_31_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_31_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_tel';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeCoord_SepAtt_tel';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeCoord_SepAtt_tel';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp};
  }

  public static getCtrl_209Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_fax';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_32_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_fax';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_32_1_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_fax';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeCoord_SepAtt_fax';
    const fifthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeCoord_SepAtt_fax';
    const sixthChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeCoord_SepAtt_fax';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp, fifthChamp, sixthChamp};
  }

  public static getCtrl_220Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepAtt_cp';
    return {firstChamp};
  }

  public static getCtrl_221Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp};
  }

  public static getCtrl_222Names_json(): any {
    const firstChamp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp};
  }

  public static getCtrl_238Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_objetAvis';
    return {firstChamp};
  }

  public static getCtrl_263Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_nomvoie';
    const secondChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_num';
    const thirdChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepSep_TypeVoie_SepAtt_typevoie';
    return {firstChamp, secondChamp, thirdChamp};
  }

  public static getCtrl_406Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepAtt_conditionsRemise';
    return {firstChamp};
  }

  public static getCtrl_1169Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return {firstChamp};
  }

  public static getCtrl_1203Names_json(): any {
    const firstChamp = '_SepSep_Initial_SepSep_TypeOuiNon_SepAtt_oui';
    return {firstChamp};
  }

  public static getCtrl_28_1Names_json(): any {
    const critere = '_SepSep_Initial_SepSep_TypeCrJugement_index_INDEX_28_1_SepSep_CriterePondere_SepAtt_critere';
    const criterePoids = '_SepSep_Initial_SepSep_TypeCrJugement_index_INDEX_28_1_SepSep_CriterePondere_SepAtt_criterePCT';
    return {critere, criterePoids};
  }

  public static getCtrl_28_2Names_json(): any {
    const critereLibre = '_SepSep_Initial_SepSep_TypeCrJugement_SepAtt_critereLibre';
    return {critereLibre};
  }

  public static getCtrl_29Names_json(iter): any {
    const critere = '_SepSep_Initial_SepSep_TypeCrJugement_index_' + iter + '_SepSep_CriterePondere_SepAtt_critere';
    return {critere};
  }

  public static getCtrl_49Names_json(): any {
    const typeRensa = '_SepSep_Initial_SepSep_TypeRensA_SepAtt_typerensaSelect';
    return {typeRensa};
  }

  public static getCtrl_92Names_json(): any {
    const firstChamp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville';
    const secondChamp = 'adm_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_92_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville';
    const thirdChamp = 'tech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAnnexeATA_index_INDEX_92_1_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville';
    const fourthChamp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_ville';
    return {firstChamp, secondChamp, thirdChamp, fourthChamp};
  }

  public static getCtrl_117Names_json(): any {
    const mel = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeCoord_SepAtt_mel';
    return {mel};
  }

  public static getCtrl_9410Names_json(): any {
    const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_objetAvis';
    return {firstChamp};
  }

  public static getCtrl_73Names_json(): any {
    const dateRecepOffre = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptionOffres';
    return {date: dateRecepOffre};
  }

  public static getCtrl_416Names_json(): any {
    const dateEnvoiInvitation = '_SepSep_Initial_SepSep_TypeDelais_SepAtt_envoiInvitation';
    return {date: dateEnvoiInvitation};
  }

  public static getCtrl_403Names_json(iter): any {
    const critere = '_SepSep_Initial_SepSep_TypeCrJugement_index_' + iter + '_SepSep_CriterePondere_SepAtt_critere';
    const criterePCT = '_SepSep_Initial_SepSep_TypeCrJugement_index_' + iter + '_SepSep_CriterePondere_SepAtt_criterePCT';

    return {critere, criterePCT};
  }

  public static getCtrl_facturationNames_json(): any {
    return {etat: MapaINControlNames.facturationEtat, siret: MapaINControlNames.facturationSiret};
  }

  public static getCtrl_TrimNames_json(): any {
    return {text: MapaINControlNames.adr3};
  }
}
